(function() {
  // Cached references
  const container = document.getElementById('announcement-bar');
  if (!container) return;
  const items = container.querySelectorAll('.announcement-item');
  if (items.length <= 1) return; // no slideshow needed

  let currentIndex = 0;
  const fadeDuration = window.announcementSettings.fadeTransition || 1000;
  const autoplayDelayBase = window.announcementSettings.autoplayDelay || 3000;
  let timeoutId = null;

  // Set CSS fade duration variable for styling
  container.style.setProperty('--fade-duration', fadeDuration + 'ms');

  // Responsive delay based on viewport
  function getAutoplayDelay() {
    const vw = window.innerWidth;
    const vh = window.innerHeight;

    if (vw < 480) return autoplayDelayBase * 0.75;
    if (vw < 768 || vh < 600) return autoplayDelayBase * 0.85;
    return autoplayDelayBase;
  }

  // Show a given slide by index
  function showItem(index) {
    const slide = items[index];
    if (!slide) return;

    // Set container height smoothly matching slide height
    const newHeight = slide.offsetHeight;
    container.style.height = newHeight + 'px';

    // Activate only the selected slide
    items.forEach((item, i) => {
      item.classList.toggle('active', i === index);
    });
  }

  // Advance to next slide
  function nextItem() {
    currentIndex = (currentIndex + 1) % items.length;
    showItem(currentIndex);
  }

  // Start automatic cycling
  function startCycle() {
    const delay = getAutoplayDelay() + fadeDuration;
    timeoutId = setTimeout(() => {
      nextItem();
      startCycle();
    }, delay);
  }

  // Stop timer (e.g. for resize handling)
  function stopCycle() {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
  }

  // Initialize slider on full window load (fonts, styles ready)
  window.addEventListener('load', () => {
    // Immediately show first slide and set container height
    showItem(0);

    // Start cycle after fade animation completes so first slide is fully visible initially
    setTimeout(() => {
      startCycle();
    }, fadeDuration);
  });

  // On resize, reset height & restart cycle
  window.addEventListener('resize', () => {
    stopCycle();
    // Set height to currently visible slide height
    container.style.height = items[currentIndex].offsetHeight + 'px';
    // Restart the cycling timer
    startCycle();
  });
})();